module.exports = __webpack_public_path__ + "img/thue.21f90a41.png";